<rk-card
  [name]="title"
  [hasError]="criteriaForm.invalid"
  (removeAction)="deleteCriteria.emit(index)"
>
  <ng-container [formGroup]="criteriaForm">
    <div class="criteria flex flex-col">
      <rk-dropdown-autocomplete
        [data]="generateOperatorsInput()"
        formControlName="operator"
      ></rk-dropdown-autocomplete>
      <rk-form-field *ngIf="!isBetweenInput(); else betweenInput">
        <input type="number" rkInput pKeyFilter="num" formControlName="value" />
      </rk-form-field>
      <ng-template #betweenInput>
        <div class="flex">
          <rk-form-field>
            <input
              type="number"
              rkInput
              pKeyFilter="num"
              formControlName="betweenFirstValue"
            />
          </rk-form-field>
          <div class="between-and">et</div>
          <rk-form-field>
            <input
              type="number"
              rkInput
              pKeyFilter="num"
              formControlName="betweenSecondValue"
            />
          </rk-form-field>
        </div>
      </ng-template>
    </div>
  </ng-container>
</rk-card>
